import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useContext } from "react"
import Hamburger from 'hamburger-react'

import {
  GlobalStateContext,
} from "../context/GlobalContextProvider"

const Header = ({ siteTitle }) => {
  const [isOpen, setOpen] = useState(false);
  const state = useContext(GlobalStateContext);

  let color = isOpen ? "#FFF" : "#000";

  if(state.theme === 'dark' ){
    color = "#FFF";
  }

  return (
    <header
      style={{
        marginBottom: `1.45rem`,
        borderBottom: `1px solid #e0e7ea`
      }}
    >
      <div
        className="flex justify-between"
        style={{
          margin: `0 auto`,
          maxWidth: 1000,
          padding: `1.45rem 1.0875rem`,
        }}
      >
        <h1 className="font-bold text-2xl tracking-tighter">
          <Link
            to="/"
          >
            {siteTitle}
          </Link>
        </h1>
        <nav className="flex flex-col justify-center">
          <ul
              className={`text-xl navigationList ${
                isOpen ? "navigationCollapsed" : ""
              }`}
            >
              <li className="mr-6">
                <Link to="/">
                  Home
                </Link>
              </li>
              <li className="mr-6">
                <Link to="/blog">
                  Blog
                </Link>
              </li>
          </ul>
        </nav>
        
        <div
            className={`flex lg:hidden responsiveMenu ${
              isOpen ? "fixedResponsiveMenu" : ""
            }`}
          >
            <Hamburger color={color} toggled={isOpen} toggle={setOpen} />
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
